import React from 'react';
import { getPreferredLocationData } from 'utils/constants';
import DesktopNotification from '../DesktopNotification';

export default function LocationChanged({ newPreferredLocation, ...rest }) {
  const changedLocation = getPreferredLocationData(newPreferredLocation);
  const locationName = changedLocation?.name || newPreferredLocation;
  return (
    <DesktopNotification
      title={'Location Changed!'}
      content={`Your preferred location has been changed to ${locationName}`}
      iconSrc={changedLocation?.image}
      footer={
        <div
          className="btn btn-success location-changed-button"
          role="button"
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Close</span>
        </div>
      }
      {...rest}
    />
  );
}
